import axios from "axios";
import { AppSettings } from "./AppSettings"

export default axios.create({
    baseURL: AppSettings.Url,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});